import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/chamada`

    return {
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}